var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfileEdit/MemberProfileEditPassword.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEditPassword.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <div class=\"MemberProfileEditPassword\">\n        <div class=\"MemberProfileEditPassword-body MemberProfileEdit-scrollbox\">\n            <div class=\"MemberProfileEditPassword-body-title\">Change Password</div>\n            <form class=\"MemberProfileEditPassword-body-form\">\n                <div class=\"MemberProfileEditPassword-body-form-inputWrapper\">\n                    <div class=\"MemberProfileEditPassword-body-form-input-label\">\n                        Current password:\n                    </div>\n                    <div class=\"MemberProfileEditPassword-body-form-input-forgotPass\">\n                        Forgot password?\n                    </div>\n                    <input class=\"MemberProfileEditPassword-body-form-input\" type=\"password\" name=\"curPass\">\n                </div>\n                <div class=\"MemberProfileEditPassword-body-form-inputWrapper\">\n                    <div class=\"MemberProfileEditPassword-body-form-input-label\">\n                        New password:\n                    </div>\n                    <input class=\"MemberProfileEditPassword-body-form-input\" type=\"password\" name=\"newPass\">\n                </div>\n                <div class=\"MemberProfileEditPassword-body-form-inputWrapper\">\n                    <div class=\"MemberProfileEditPassword-body-form-input-label\">\n                        Confirm password:\n                    </div>\n                    <input class=\"MemberProfileEditPassword-body-form-input\" type=\"password\" name=\"confirmPass\">\n                </div>\n            </form>\n        </div>\n        <div class=\"MemberProfileEditPassword-buttons\">\n            <div class=\"MemberProfileEditPassword-buttons-button MemberProfileEditPassword-buttons-button--cancel\">\n                cancel\n            </div>\n            <div class=\"MemberProfileEditPassword-buttons-button MemberProfileEditPassword-buttons-button--save\">\n                save\n            </div>\n        </div>\n\n        <div class=\"MemberProfileEditPassword-confirmPopup hidden\">\n            <div class=\"MemberProfileEditPassword-confirmPopup-body\">\n                <div class=\"MemberProfileEditPassword-confirmPopup-body-title\">\n                    Thanks, ";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"firstName"), env.opts.autoescape);
t_5 += "!\n                </div>\n                <div class=\"MemberProfileEditPassword-confirmPopup-body-text\">\n                    Your password has been successfully updated. Please be sure to log in with your new password on all\n                    your devices.\n                </div>\n                <div class=\"MemberProfileEditPassword-confirmPopup-body-btnWrap\">\n                    <div class=\"MemberProfileEditPassword-confirmPopup-body-btn\">\n                        Close\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("MemberProfileEditPassword");
context.setVariable("MemberProfileEditPassword", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfileEdit/MemberProfileEditPassword.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditPassword.jinja
// module id = 115
// module chunks = 0